















import Vue from 'vue'
export default Vue.extend({
  data() {
    return {
      instructionsVisible: false
    }
  },
  mounted() {

  },
  methods: {
    startGame(): void {
      this.$store.dispatch('startGame');
    },
    resetGame(): void {
      this.$store.dispatch('resetGame')
    }
  },
  computed: {
    score(): string {
      return `${this.$store.state.score}/${this.$store.state.possibleScore}`
    },
    gameOver(): boolean {
      return this.$store.state.gameOver
    }
  }
})
